import { BaseLayout } from "@components/general/base_layout";
import { Header } from "@components/general/header";
import { Outlet } from "react-router-dom";

import PreloadLogo from "@assets/images/logo-deha.png";
import { useThemeStore } from "@stores/theme.store";
import { useEffect } from "react";

export const AuthPage = () => {
  const { setBottomNavigation, setAppBar } = useThemeStore((state) => state);
  useEffect(() => {
    setBottomNavigation("hidden");
    setAppBar({ show: false, fixed: false });
  }, [setBottomNavigation, setAppBar]);
  return (
    <BaseLayout>
      <div className="tw-flex tw-flex-col tw-min-h-screen">
        <Header>
          <div
            className="tw-relative tw-overflow-hidden tw-text-center"
            style={{
              background:
                "linear-gradient(160deg, #0f5fa8 0%, #56b6fd 55%, #3b82f6 100%)",
            }}
          >
            {/* Dekorasi lingkaran */}
            <div
              className="tw-absolute tw-top-[-30px] tw-right-[-36px] tw-w-44 tw-h-44 tw-rounded-full"
              style={{ background: "rgba(255,255,255,0.08)" }}
            />
            <div
              className="tw-absolute tw-bottom-16 tw-left-[-28px] tw-w-32 tw-h-32 tw-rounded-full"
              style={{ background: "rgba(255,255,255,0.07)" }}
            />

            <div className="tw-relative tw-z-10 tw-pt-14 tw-pb-20 tw-px-8">
              <img
                src={PreloadLogo}
                alt="Logo Darul Hidayah"
                className="tw-w-24 tw-h-24 tw-mx-auto tw-mb-4 tw-object-contain"
                style={{ filter: "drop-shadow(0 6px 14px rgba(0,0,0,0.25))" }}
              />
              <div className="tw-text-white/80 tw-text-xs tw-font-medium tw-tracking-wide">
                Pondok Pesantren
              </div>
              <div className="tw-text-white tw-text-2xl tw-font-bold">
                Darul Hidayah
              </div>
              <div className="tw-text-white/60 tw-text-[11px] tw-mt-1">
                Rasau Jaya, Kubu Raya
              </div>
            </div>

            <svg
              viewBox="0 0 100 12"
              preserveAspectRatio="none"
              style={{
                position: "absolute",
                bottom: "-1px",
                left: 0,
                width: "100%",
                height: "70px",
              }}
            >
              <path
                d="M0,4 Q25,12 50,5 Q75,-2 100,4 L100,30 L0,30 Z"
                fill="#f7f7f8"
              />
            </svg>
          </div>
        </Header>
        <Outlet />
      </div>
    </BaseLayout>
  );
};
